import React from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import * as actionCreators from "../actions/userActivity";
import { bindActionCreators } from "redux";

const RouteWatcher = withRouter((props) => {
  if (props.userActivity.timerRunning) {
    const path = props.location.pathname;
    const page = path.split("/")[1];

    //Move this all to userLocation hook in timerProvider after upgrading react-router-dom > v6.0.0
    if (
      page !== "manage-users" &&
      page !== "manage-user-customapp" &&
      page !== "patient-progress" &&
      page !== "custom-app-goal"
    ) {
      props.saveSessionAndClearTimer(
        -53,
        props.userActivity.customAppId,
        props.userActivity.currentSession
      );
    }
  }
  return null;
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

const mapStateToProps = ({ userActivity }, props) => ({
  userActivity,
  props,
});

export default connect(mapStateToProps, mapDispatchToProps)(RouteWatcher);



// WEBPACK FOOTER //
// ./src/providers/routeWatcher.js